import React, { createContext, useState, useContext } from 'react';

const BannerContext = createContext();

export const BannerProvider = ({ children }) => {
  const [showBanner, setShowBanner] = useState(true);

  const toggleBanner = (value) => {
    setShowBanner(value);
  };

  return (
    <BannerContext.Provider value={{ showBanner, toggleBanner }}>
      {children}
    </BannerContext.Provider>
  );
};

export const useBanner = () => useContext(BannerContext);

export default BannerContext; 